import React from 'react';

export const prideLogo = (
  <svg xmlns="http://www.w3.org/2000/svg" width="196" height="42" viewBox="0 0 196 42" fill="none">
    <g clipPath="url(#clip0_2007_2263)">
      <path
        d="M150.516 33.2004C151.228 33.2004 151.885 33.4017 152.487 33.8042V35.1988C151.871 34.602 151.208 34.3038 150.495 34.3038C150.094 34.3038 149.762 34.3941 149.506 34.5815C149.251 34.7689 149.119 35.0049 149.119 35.2963C149.12 35.553 149.216 35.7957 149.403 36.0177C149.59 36.2398 149.9 36.476 150.315 36.7258L151.249 37.2812C152.293 37.9057 152.819 38.7034 152.819 39.6749C152.819 40.3618 152.59 40.9242 152.127 41.3545C151.671 41.7847 151.069 41.9999 150.337 42C149.493 42 148.718 41.7363 148.027 41.216V39.654C148.691 40.4937 149.458 40.9174 150.323 40.9174C150.71 40.9174 151.028 40.8132 151.284 40.598C151.539 40.3829 151.664 40.1124 151.664 39.7932C151.664 39.2658 151.283 38.7731 150.537 38.3012L149.604 37.7323C149.016 37.3715 148.601 37.0243 148.359 36.6774C148.11 36.3304 147.985 35.9343 147.985 35.4832C147.985 34.8032 148.221 34.2551 148.691 33.8318C149.161 33.4085 149.769 33.2004 150.516 33.2004Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0856 33.3948C46.7078 33.3948 47.2196 33.5679 47.6275 33.9286C48.0354 34.2826 48.2499 34.7411 48.2637 35.2963C48.2844 36.2469 47.517 37.0656 46.7565 37.5098L48.3051 39.2035C48.6438 38.6554 48.9133 37.9404 49.024 37.5864H50.0824C50.0063 38.0445 49.5292 39.2935 49.0107 39.9667L50.8014 41.9099H49.2521L48.2911 40.8966C47.489 41.646 46.5073 42.076 45.3319 41.9859C43.9007 41.8818 43.3334 40.9592 43.2158 40.2444C43.0429 39.1548 43.5135 38.4955 44.2395 37.8917C44.3986 37.7598 44.8549 37.4545 45.0485 37.3504C44.3916 36.594 44.0458 36.0593 43.9974 35.3723C43.956 34.7825 44.1705 34.3105 44.5576 33.9428C44.9448 33.5751 45.4564 33.3948 46.0856 33.3948ZM45.7674 38.1828C45.0276 38.627 44.1007 39.3285 44.5917 40.4111C45.0136 41.3201 46.7772 41.0423 47.5655 40.1401C47.1512 39.6828 45.7785 38.1805 45.7674 38.1828ZM46.1342 34.4423C45.6156 34.4562 45.1725 34.769 45.1725 35.2479C45.1657 35.5115 45.27 35.7754 45.4013 36.0043C45.5534 36.2748 45.7744 36.5386 46.0509 36.7883C46.3067 36.6217 46.5212 36.4551 46.6871 36.2954C46.9844 36.004 47.2399 35.6085 47.164 35.1645C47.0879 34.7135 46.6596 34.4286 46.1342 34.4423Z"
        fill="#231F20"
      />
      <path
        d="M103.331 34.3939H100.351V41.9099H99.1204V34.3939H96.14V33.2973H103.331V34.3939Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.001 33.2973C64.8169 33.2973 65.4738 33.5195 65.9578 33.9636C66.4418 34.4077 66.6907 35.0049 66.6907 35.7474C66.6907 36.247 66.5804 36.7052 66.3246 37.0868C66.0895 37.4476 65.7299 37.746 65.2875 37.9125C64.762 38.1138 64.2776 38.1761 63.4202 38.1761H62.4938V41.9031H61.2627V33.2973H64.001ZM62.4938 37.0794H63.8557C64.7753 37.0794 65.4116 36.6702 65.4116 35.7125C65.4185 34.8312 64.8724 34.394 63.787 34.3939H62.4938V37.0794Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.2475 41.9025H77.9964L76.8553 39.3561H73.2046L72.1328 41.9025H70.8743L74.5457 33.2556H75.4101L79.2475 41.9025ZM73.6814 38.2595H76.3437L74.9606 35.1436L73.6814 38.2595Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.3446 33.3047C88.2089 33.3047 88.9006 33.5192 89.4054 33.9495C89.917 34.3797 90.1656 34.9628 90.1657 35.6984C90.1657 36.198 90.0411 36.6283 89.7922 36.9961C89.5433 37.3639 89.2044 37.6346 88.7411 37.815C89.0177 37.9954 89.2807 38.2453 89.5434 38.5506C89.8062 38.8629 90.1588 39.4046 90.6359 40.1818C90.9332 40.6676 91.189 41.0354 91.3688 41.2852L91.825 41.9025H90.3524C90.3431 41.8877 89.9577 41.2774 89.9236 41.2294L89.3087 40.2652L88.8519 39.5922C88.596 39.2382 88.3679 38.9464 88.1536 38.7382C87.9462 38.5301 87.7802 38.3914 87.6074 38.3012C87.4345 38.211 87.1301 38.162 86.729 38.162H86.4109V41.9025H85.1738V33.3047H87.3446ZM86.4249 37.066H86.8884C87.5107 37.066 87.9325 37.0101 88.1676 36.906C88.6653 36.677 88.9005 36.1983 88.9005 35.6849C88.9005 35.1505 88.6028 34.6645 88.0842 34.484C87.8215 34.4008 87.3929 34.3523 86.7917 34.3522H86.4249V37.066Z"
        fill="#231F20"
      />
      <path
        d="M116.324 39.9808V33.3047H117.478V41.9025H116.427L110.661 35.2822V41.9025H109.506V33.3047H110.501L116.324 39.9808Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M137.959 33.3047C138.824 33.3047 139.515 33.5192 140.02 33.9495C140.532 34.3797 140.78 34.9628 140.78 35.6984C140.78 36.198 140.656 36.6283 140.407 36.9961C140.158 37.3639 139.819 37.6346 139.356 37.815C139.632 37.9954 139.895 38.2453 140.158 38.5506C140.421 38.8629 140.773 39.4046 141.25 40.1818C141.548 40.6676 141.804 41.0354 141.983 41.2852L142.44 41.9025H140.967C140.958 41.8885 140.572 41.2774 140.538 41.2294L139.923 40.2652L139.466 39.5922C139.211 39.2382 138.983 38.9464 138.768 38.7382C138.561 38.5301 138.395 38.3914 138.222 38.3012C138.049 38.211 137.745 38.162 137.344 38.162H137.026V41.9025H135.788V33.3047H137.959ZM137.04 37.066H137.503C138.125 37.066 138.547 37.0101 138.782 36.906C139.28 36.677 139.515 36.1983 139.515 35.6849C139.515 35.1505 139.217 34.6645 138.699 34.484C138.436 34.4008 138.008 34.3523 137.406 34.3522H137.04V37.066Z"
        fill="#231F20"
      />
      <path
        d="M129.254 34.4007H125.624V37.0243H129.129V38.1277H125.624V40.7991H129.371V41.8958H124.4V33.3047H129.254V34.4007Z"
        fill="#231F20"
      />
      <path
        d="M195.723 3.11581H186.624V9.59763H195.412V12.3665H186.624V19.0359H196V21.8048H183.554V0.346924H195.723V3.11581Z"
        fill="url(#paint0_linear_2007_2263)"
      />
      <path
        d="M167.768 0.0349731C169.738 0.0349789 171.191 0.534248 172.677 1.54045V5.02476C171.135 3.5397 169.476 2.79654 167.706 2.79647C166.703 2.79647 165.887 3.02608 165.244 3.49104C164.601 3.95601 164.283 4.56659 164.283 5.28834C164.283 5.93366 164.442 6.46102 164.912 7.02309C165.389 7.58522 166.226 8.24443 167.277 8.86207L169.704 10.2499C172.311 11.8113 173.527 13.8036 173.527 16.2187C173.527 17.9397 172.933 19.3555 171.785 20.4312C170.638 21.5068 169.164 22.076 167.325 22.0483C165.216 22.0135 163.329 21.4232 161.559 20.0701V16.1696C163.211 18.2724 165.127 19.2787 167.298 19.2787C168.259 19.2787 169.054 19.0566 169.69 18.5223C170.326 17.9879 170.672 17.3148 170.672 16.5098C170.672 15.1913 169.704 13.9562 167.83 12.7834L165.507 11.3674C164.048 10.4721 163.128 9.57697 162.457 8.75113C161.766 7.89062 161.427 6.83545 161.427 5.71127C161.428 4.025 162.008 2.65106 163.177 1.59626C164.345 0.541451 165.901 0.0349731 167.768 0.0349731Z"
        fill="url(#paint1_linear_2007_2263)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.642 0C143.947 3.71686e-05 146.693 1.04807 148.891 3.15081C151.09 5.24656 152.189 7.88362 152.189 11.048C152.189 14.2126 151.083 16.8292 148.863 18.9042C146.644 20.9791 143.85 22.0133 140.476 22.0133C137.254 22.0133 134.571 20.9791 132.428 18.9042C130.284 16.8292 129.205 14.2335 129.205 11.1105C129.205 7.9044 130.284 5.25333 132.448 3.15753C134.606 1.04789 137.337 0 140.642 0ZM140.766 2.92152C138.319 2.92157 136.307 3.69221 134.737 5.22579C133.161 6.75946 132.372 8.7233 132.372 11.1105C132.372 13.4215 133.161 15.3513 134.744 16.885C136.32 18.4186 138.298 19.1886 140.677 19.1886C143.062 19.1885 145.054 18.4043 146.644 16.8359C148.241 15.2675 149.036 13.3172 149.036 10.9855C149.036 8.70935 148.241 6.80109 146.644 5.24664C145.047 3.69211 143.09 2.92152 140.766 2.92152Z"
        fill="url(#paint2_linear_2007_2263)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.958 0.346924C113.122 0.346924 114.837 0.881634 116.109 1.95729C117.381 3.03297 118.018 4.48337 118.018 6.32243C118.018 7.57148 117.706 8.65429 117.084 9.56334C116.462 10.4723 115.625 11.1523 114.464 11.6034C115.148 12.0544 115.812 12.6718 116.469 13.4491C117.119 14.2263 118.004 15.5868 119.193 17.5231C119.94 18.7444 120.569 19.6604 121.019 20.2711L122.153 21.8048H118.467C118.459 21.792 117.485 20.251 117.395 20.1326L115.853 17.7174L114.712 16.0452C114.083 15.1638 113.503 14.4348 112.977 13.9144C112.452 13.3939 112.036 13.0467 111.615 12.8177C111.193 12.5888 110.418 12.4707 109.416 12.4707H108.621V21.8122H105.537V0.346924H110.958ZM108.655 9.73681H109.817C111.366 9.7368 112.431 9.60448 113.012 9.34078C113.586 9.07706 114.035 8.6744 114.36 8.13317C114.678 7.59188 114.844 6.9812 114.844 6.29419C114.844 5.6211 114.664 5.00319 114.312 4.46193C113.952 3.91385 113.454 3.52548 112.804 3.30341C112.154 3.0744 111.075 2.96319 109.575 2.96318H108.655V9.73681Z"
        fill="url(#paint3_linear_2007_2263)"
      />
      <path
        d="M96.3334 3.07413H88.9145V21.8048H85.844V3.08152H78.4112V0.346924H96.3334V3.07413Z"
        fill="url(#paint4_linear_2007_2263)"
      />
      <path
        d="M69.2911 21.8048H66.2206V0.346924H69.2911V21.8048Z"
        fill="url(#paint5_linear_2007_2263)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.5499 21.8048H54.4174L51.569 15.4481H42.4482L39.7792 21.8048H36.6333L45.8088 0.221863H47.9596L57.5499 21.8048ZM43.6586 12.7135H50.3105L46.8599 4.94135L43.6586 12.7135Z"
        fill="url(#paint6_linear_2007_2263)"
      />
      <path
        d="M8.96808 15.1361L14.887 0.346924H17.8048L23.7584 15.1361L29.5946 0.346924H32.6298L23.9518 21.9991H23.3576L16.3322 4.44176L9.24486 21.9991H8.64996L0 0.346924H3.06984L8.96808 15.1361Z"
        fill="url(#paint7_linear_2007_2263)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2007_2263"
        x1="183.554"
        y1="11.0769"
        x2="196"
        y2="11.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5396C0" />
        <stop offset="1" stopColor="#6F2A80" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2007_2263"
        x1="161.43"
        y1="11.0403"
        x2="173.53"
        y2="11.0403"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#73BB44" />
        <stop offset="0.15" stopColor="#70B74D" />
        <stop offset="0.4" stopColor="#6AAC66" />
        <stop offset="0.72" stopColor="#609A8F" />
        <stop offset="1" stopColor="#5689BA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2007_2263"
        x1="129.205"
        y1="11.0056"
        x2="152.189"
        y2="11.0056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F48020" />
        <stop offset="0.1" stopColor="#F5891D" />
        <stop offset="0.27" stopColor="#F9A216" />
        <stop offset="0.47" stopColor="#FFC80C" />
        <stop offset="1" stopColor="#089347" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2007_2263"
        x1="105.535"
        y1="11.0806"
        x2="122.153"
        y2="11.0806"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE3935" />
        <stop offset="0.16" stopColor="#EE4232" />
        <stop offset="0.43" stopColor="#F05B2A" />
        <stop offset="0.74" stopColor="#F48020" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2007_2263"
        x1="78.4112"
        y1="11.0759"
        x2="96.3334"
        y2="11.0759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#72CEEF" />
        <stop offset="0.07" stopColor="#78C6E5" />
        <stop offset="0.18" stopColor="#89B2CC" />
        <stop offset="0.32" stopColor="#A491A2" />
        <stop offset="0.49" stopColor="#C96469" />
        <stop offset="0.63" stopColor="#EE3933" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2007_2263"
        x1="66.2206"
        y1="11.0769"
        x2="69.2911"
        y2="11.0769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5A3BD" />
        <stop offset="0.14" stopColor="#EBA6C0" />
        <stop offset="0.37" stopColor="#D2AECA" />
        <stop offset="0.66" stopColor="#A8BBD9" />
        <stop offset="0.99" stopColor="#6FCDEE" />
        <stop offset="1" stopColor="#6FCEEF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2007_2263"
        x1="36.6354"
        y1="11.0133"
        x2="57.5521"
        y2="11.0133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9DDD7" />
        <stop offset="0.25" stopColor="#EAD3D2" />
        <stop offset="0.67" stopColor="#F0BAC6" />
        <stop offset="1" stopColor="#F5A2BB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2007_2263"
        x1="0"
        y1="11.173"
        x2="32.6298"
        y2="11.173"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E1012" />
        <stop offset="0.07" stopColor="#171514" />
        <stop offset="0.19" stopColor="#30221B" />
        <stop offset="0.33" stopColor="#5A3827" />
        <stop offset="0.51" stopColor="#935737" />
        <stop offset="0.99" stopColor="#E9DCD7" />
      </linearGradient>
      <clipPath id="clip0_2007_2263">
        <rect width="196" height="42" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const prideLogoSmall = (
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="22" viewBox="0 0 80 22" fill="none">
    <g clipPath="url(#clip0_482_28)">
      <path
        d="M68.6907 15.6698C69.2048 15.6698 69.6685 15.808 70.0918 16.0944V17.0721C69.6483 16.6574 69.1747 16.4498 68.6708 16.4498C68.3885 16.4498 68.1465 16.5191 67.965 16.6475C67.7837 16.7759 67.6929 16.9439 67.6929 17.1413C67.6929 17.319 67.7637 17.4869 67.8947 17.6449C68.0257 17.8029 68.2474 17.9708 68.5497 18.1387L69.215 18.5236C69.9609 18.9581 70.334 19.5114 70.334 20.1928C70.3339 20.6766 70.1726 21.0618 69.84 21.3679C69.5075 21.6641 69.0841 21.8219 68.56 21.822C67.9553 21.822 67.4108 21.6444 66.9068 21.279V20.1928C67.3805 20.7754 67.9248 21.0714 68.5497 21.0715C68.8218 21.0715 69.0536 20.9924 69.235 20.8443C69.4164 20.6962 69.5071 20.5087 69.5072 20.2817C69.5072 19.8965 69.2352 19.5508 68.7011 19.2249L68.0358 18.8298C67.6225 18.5829 67.32 18.336 67.1486 18.0892C66.9672 17.8522 66.8868 17.5657 66.8868 17.2596C66.8868 16.7856 67.0581 16.4004 67.3908 16.1141C67.7233 15.8179 68.1567 15.6698 68.6907 15.6698Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7424 15.8078C12.1859 15.8078 12.5487 15.9364 12.841 16.1832C13.1333 16.4301 13.2845 16.746 13.2946 17.1311C13.3046 17.7927 12.7606 18.3656 12.2164 18.6718L13.2946 19.8272C13.5264 19.4717 13.6677 19.0864 13.8189 18.7013H14.6553C14.5142 19.3135 14.2321 19.9062 13.8592 20.4197L15.1292 21.7331H14.0203L13.3349 21.0322C12.7604 21.5555 12.0547 21.8517 11.2181 21.7925C10.1902 21.7134 9.787 21.0813 9.70637 20.5777C9.57537 19.8173 9.91805 19.3531 10.4321 18.9383C10.543 18.8495 10.8656 18.6423 11.0067 18.5633C10.5431 18.0399 10.2909 17.6645 10.2607 17.1905C10.2304 16.7757 10.3817 16.4498 10.6539 16.1931C10.926 15.9363 11.2889 15.8078 11.7424 15.8078ZM11.5207 19.1459C11.0066 19.452 10.6638 19.689 10.5832 20.1433C10.5025 20.6074 10.7144 21.1208 11.4703 21.0911C12.2162 21.0615 12.5991 20.6764 12.7906 20.5085C12.5012 20.1858 11.5304 19.157 11.5207 19.1459ZM11.7628 16.5882C11.4201 16.598 11.1174 16.845 11.1174 17.1511C11.1074 17.3288 11.1782 17.5066 11.2689 17.6547C11.3697 17.8324 11.5207 18.0102 11.7021 18.1682C11.8835 18.0595 12.0248 17.9509 12.1357 17.8423C12.3372 17.6546 12.5085 17.388 12.4582 17.1016C12.4078 16.8054 12.1155 16.5784 11.7628 16.5882Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.4313 15.739C35.046 15.739 35.5399 15.887 35.9027 16.1931C36.2655 16.4893 36.447 16.8943 36.447 17.4078C36.447 17.7534 36.3562 18.0596 36.1848 18.3164C36.0034 18.5731 35.7717 18.7608 35.4391 18.8892C35.6306 19.0176 35.8223 19.1854 36.0138 19.4026C36.2053 19.6199 36.4573 19.9953 36.7898 20.5384C37.0014 20.874 37.1827 21.1308 37.3137 21.3085L37.6362 21.7331H36.588C36.5841 21.7271 36.3059 21.2983 36.2859 21.2688L35.8423 20.5974L35.5198 20.1335C35.3385 19.8866 35.1771 19.6792 35.0259 19.541C34.8747 19.3929 34.7536 19.294 34.6327 19.2347C34.5117 19.1656 34.2899 19.1361 34.0077 19.1361H33.7759V21.743H32.8788V15.739H34.4313ZM33.7659 18.3655H34.0984C34.5419 18.3655 34.8446 18.3262 35.0159 18.257C35.3686 18.099 35.5398 17.7633 35.5398 17.4078C35.5398 17.0326 35.3281 16.6969 34.9552 16.5685C34.7637 16.5093 34.4614 16.4793 34.0281 16.4793H33.7659V18.3655Z"
        fill="#231F20"
      />
      <path
        d="M50.9208 20.4V15.7488H51.7576V21.743H51.0015L46.8791 17.1311V21.743H46.0626V15.7488H46.7684L50.9208 20.4Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.9076 15.739C62.5223 15.739 63.0161 15.887 63.379 16.1931C63.7418 16.4893 63.9233 16.8943 63.9233 17.4078C63.9233 17.7534 63.8328 18.0597 63.6615 18.3164C63.4801 18.5731 63.248 18.7608 62.9154 18.8892C63.1069 19.0176 63.2986 19.1854 63.4901 19.4026C63.6816 19.6199 63.9335 19.9953 64.2661 20.5384C64.4777 20.874 64.659 21.1308 64.7901 21.3085L65.1129 21.7331H64.0643C64.0595 21.7256 63.7822 21.2982 63.7622 21.2688L63.3186 20.5974L62.9961 20.1335C62.8147 19.8866 62.6534 19.6792 62.5022 19.541C62.351 19.3929 62.2299 19.294 62.109 19.2347C61.988 19.1656 61.7662 19.1361 61.484 19.1361H61.2522V21.743H60.3554V15.739H61.9076ZM61.2422 18.3655H61.5747C62.0182 18.3655 62.3209 18.3262 62.4922 18.257C62.8449 18.099 63.0161 17.7633 63.0161 17.4078C63.0161 17.0326 62.8044 16.6969 62.4315 16.5685C62.24 16.5093 61.9377 16.4793 61.5044 16.4793H61.2422V18.3655Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4188 15.739C22.0033 15.739 22.4668 15.8969 22.8195 16.2029C23.1622 16.509 23.3438 16.9238 23.3438 17.4472C23.3438 17.7928 23.2631 18.1189 23.0817 18.3856C22.9103 18.6324 22.6584 18.8498 22.346 18.9584C21.9731 19.0966 21.6303 19.1459 21.0156 19.1361H20.3503V21.7331H19.4631V15.739H21.4188ZM20.3503 18.3754H21.3281C21.9832 18.3753 22.4367 18.0891 22.4367 17.4275C22.4266 16.8054 22.0435 16.4993 21.2674 16.4993H20.3503V18.3754Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8327 21.7331H29.9356L29.1191 19.9558H26.5088L25.7427 21.7331H24.8456L27.4763 15.7091H28.0913L30.8327 21.7331ZM26.8617 19.1951H28.7667L27.7788 17.0226L26.8617 19.1951Z"
        fill="#231F20"
      />
      <path
        d="M43.9562 16.4993H41.8294V21.7331H40.9527V16.4993H38.8259V15.739H43.9562V16.4993Z"
        fill="#231F20"
      />
      <path
        d="M57.8354 16.5091H55.2451V18.336H57.7447V19.1062H55.2451V20.963H57.9162V21.7233H54.3683V15.7488H57.8354V16.5091Z"
        fill="#231F20"
      />
      <path
        d="M79.8789 1.59714H75.8472V4.30308H79.7379V5.59688H75.8472V8.38147H80V9.67527H74.3857V0.303711H79.8789V1.59714Z"
        fill="url(#paint0_linear_482_28)"
      />
      <path
        d="M68.4186 0.184937C69.2653 0.184937 69.9206 0.382468 70.6261 0.846582L70.6465 0.856414V2.49578L70.5658 2.41676C69.9005 1.78474 69.1647 1.4689 68.3986 1.4689C67.9754 1.4689 67.6126 1.56751 67.3404 1.76495C67.0784 1.96244 66.9373 2.20939 66.9372 2.50561C66.9372 2.792 67.0079 3.00936 67.1994 3.22661C67.411 3.46357 67.7838 3.74004 68.2372 4.00661L69.3158 4.60926C70.4749 5.29066 71.0293 6.14001 71.0293 7.23618C71.0293 7.98661 70.7673 8.6186 70.2433 9.09258C69.7192 9.56658 69.074 9.80373 68.2979 9.80375H68.2272C67.2495 9.78398 66.4028 9.49742 65.6469 8.93454L65.6269 8.92471V7.06831L65.7176 7.17683C66.4332 8.06556 67.2496 8.50012 68.2172 8.50012C68.6506 8.50012 68.9834 8.4013 69.2454 8.18404C69.5175 7.95692 69.6586 7.68038 69.6586 7.35453C69.6586 6.82126 69.2351 6.29782 68.4186 5.79418L67.3908 5.18206C66.8264 4.84632 66.3829 4.47094 66.0301 4.03647C65.7177 3.66125 65.5562 3.19709 65.5562 2.69351C65.5562 1.95286 65.8285 1.34022 66.3526 0.876078C66.8666 0.412037 67.562 0.184965 68.4186 0.184937Z"
        fill="url(#paint1_linear_482_28)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.4122 0.175171C58.8837 0.175198 60.1234 0.639476 61.1011 1.54799C62.0788 2.46639 62.5729 3.62189 62.5729 5.00442C62.5729 6.38685 62.0688 7.54222 61.0811 8.44083C60.0933 9.33948 58.8333 9.79397 57.3315 9.79398C55.9003 9.79398 54.6908 9.3296 53.7333 8.431C52.7758 7.52248 52.2919 6.37697 52.2919 5.02409C52.2919 3.63166 52.7757 2.45652 53.7433 1.54799C54.7109 0.63945 55.9406 0.175171 57.4122 0.175171ZM57.4526 1.54799C56.3943 1.54799 55.5072 1.87368 54.8219 2.52534C54.1365 3.17712 53.7936 4.01675 53.7936 5.03392C53.7937 6.01156 54.1465 6.8412 54.8319 7.49297C55.5172 8.14467 56.3942 8.47032 57.4222 8.47032C58.4603 8.47032 59.3372 8.13482 60.0225 7.48314C60.718 6.81161 61.0708 5.97193 61.0708 4.98439C61.0707 4.01666 60.718 3.19716 60.0225 2.53554C59.3271 1.8838 58.4604 1.54802 57.4526 1.54799Z"
        fill="url(#paint2_linear_482_28)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.2665 0.293457C46.224 0.293478 47.0103 0.530628 47.5747 1.00463C48.1391 1.47862 48.4311 2.1304 48.4312 2.93021C48.4312 3.48323 48.2902 3.95749 48.0079 4.36238C47.7358 4.75732 47.373 5.04361 46.9094 5.23122C47.1815 5.41884 47.4638 5.6756 47.7258 5.98172C47.9979 6.29773 48.3508 6.82134 48.9354 7.74963C49.2882 8.30254 49.5702 8.69755 49.7315 8.93455L50.2962 9.67521H48.5422L48.5322 9.65555C48.4113 9.46791 48.0885 8.97405 48.0583 8.93455L47.3729 7.88764L46.879 7.17683C46.5766 6.76207 46.3246 6.46585 46.113 6.25847C45.861 6.02146 45.6897 5.88306 45.5183 5.79419C45.3469 5.69546 45.0143 5.64598 44.5708 5.64598H44.2687V9.66538H42.8173V0.293457H45.2665ZM44.2887 1.53773V4.37221H44.7522C45.4275 4.37221 45.8913 4.31296 46.1433 4.20434C46.6271 3.97721 46.9194 3.51286 46.9194 2.93021C46.9294 2.35748 46.5868 1.86368 46.0526 1.68594C45.7704 1.58719 45.2966 1.53773 44.6415 1.53773H44.2887Z"
        fill="url(#paint3_linear_482_28)"
      />
      <path
        d="M39.8134 1.58731H36.5278V9.6851H35.0763V1.58731H31.7803V0.303711H39.8134V1.58731Z"
        fill="url(#paint4_linear_482_28)"
      />
      <path
        d="M28.837 9.67527H27.3756V0.303711H28.837V9.67527Z"
        fill="url(#paint5_linear_482_28)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3703 0.283646L24.6442 9.68506H23.1425L21.8825 6.9398H17.911L16.7318 9.68506H15.23L15.2603 9.61588L19.3425 0.25415H20.3603L20.3703 0.283646ZM18.4957 5.65583H21.2878L19.8364 2.46631L18.4957 5.65583Z"
        fill="url(#paint6_linear_482_28)"
      />
      <path
        d="M1.48178 0.333206L4.04177 6.61393L6.63211 0.303711H7.99282L8.00318 0.333206L10.5935 6.61393L13.1435 0.303711H14.5949L10.7142 9.76412H10.3817L7.30746 2.25879L4.2032 9.76412H3.87033L3.86034 9.73462L0 0.303711H1.47142L1.48178 0.333206Z"
        fill="url(#paint7_linear_482_28)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_482_28"
        x1="74.3857"
        y1="4.98996"
        x2="80"
        y2="4.98996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5396C0" />
        <stop offset="1" stopColor="#6F2A80" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_482_28"
        x1="65.5571"
        y1="4.99356"
        x2="71.0303"
        y2="4.99356"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#73BB44" />
        <stop offset="0.15" stopColor="#70B74D" />
        <stop offset="0.4" stopColor="#6AAC66" />
        <stop offset="0.72" stopColor="#609A8F" />
        <stop offset="1" stopColor="#5689BA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_482_28"
        x1="52.2919"
        y1="4.98411"
        x2="62.5729"
        y2="4.98411"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F48020" />
        <stop offset="0.1" stopColor="#F5891D" />
        <stop offset="0.27" stopColor="#F9A216" />
        <stop offset="0.47" stopColor="#FFC80C" />
        <stop offset="1" stopColor="#089347" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_482_28"
        x1="42.8163"
        y1="4.9848"
        x2="50.2962"
        y2="4.9848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE3935" />
        <stop offset="0.16" stopColor="#EE4232" />
        <stop offset="0.43" stopColor="#F05B2A" />
        <stop offset="0.74" stopColor="#F48020" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_482_28"
        x1="31.7803"
        y1="4.99441"
        x2="39.8134"
        y2="4.99441"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#72CEEF" />
        <stop offset="0.07" stopColor="#78C6E5" />
        <stop offset="0.18" stopColor="#89B2CC" />
        <stop offset="0.32" stopColor="#A491A2" />
        <stop offset="0.49" stopColor="#C96469" />
        <stop offset="0.63" stopColor="#EE3933" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_482_28"
        x1="27.3756"
        y1="4.98996"
        x2="28.837"
        y2="4.98996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5A3BD" />
        <stop offset="0.14" stopColor="#EBA6C0" />
        <stop offset="0.37" stopColor="#D2AECA" />
        <stop offset="0.66" stopColor="#A8BBD9" />
        <stop offset="0.99" stopColor="#6FCDEE" />
        <stop offset="1" stopColor="#6FCEEF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_482_28"
        x1="15.2309"
        y1="4.96961"
        x2="24.6452"
        y2="4.96961"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9DDD7" />
        <stop offset="0.25" stopColor="#EAD3D2" />
        <stop offset="0.67" stopColor="#F0BAC6" />
        <stop offset="1" stopColor="#F5A2BB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_482_28"
        x1="0"
        y1="5.03392"
        x2="14.5949"
        y2="5.03392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E1012" />
        <stop offset="0.07" stopColor="#171514" />
        <stop offset="0.19" stopColor="#30221B" />
        <stop offset="0.33" stopColor="#5A3827" />
        <stop offset="0.51" stopColor="#935737" />
        <stop offset="0.99" stopColor="#E9DCD7" />
      </linearGradient>
      <clipPath id="clip0_482_28">
        <rect width="80" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
